import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const styles = css`
  .carousel-container {
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  .carousel-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    width: 100%;
  }

  .carousel-content {
    display: flex;
    margin-top: 16px;
    transition: transform 0.5s ease-in-out;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      gap: 4px;
    }
  }
  .storeSpecialCaraosal {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-bottom: 44px;
    }
  }

  .storeSpecialCaraosal .carousel-arrows .right-arrow {
    position: absolute; /* Assuming you want to position it absolutely */
    right: 26px;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #d8d8d8; /* Use hex for consistency */
    background-color: rgba(255, 255, 255, 0.9);
    background-image: url(${(props) => getIconPath('icon-carrot-grey-large', props)});
    background-position: center;
    background-repeat: no-repeat;
  }

  .storeSpecialCaraosal .carousel-arrows .left-arrow {
    position: absolute; /* Assuming you want to position it absolutely */
    left: 26px;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #d8d8d8; /* Use hex for consistency */
    background-color: rgba(255, 255, 255, 0.9);
    background-image: url(${(props) => getIconPath('icon-carrot-grey-large', props)});
    background-position: center;
    background-repeat: no-repeat;
  }

  .product-tile-container {
    margin-bottom: 48px;
    margin-left: 5px;
    margin-top: 3px;
  }
  .storeSpecialCaraosal .product-tile-container {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-bottom: 4px;
    }
  }

  .store_specials_heading,
  .store_specials_subheading,
  .store_special-view_all {
    line-height: 150%;
  }

  .store_specials_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4px 0 16px;

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0 12px;
    }
  }
  .store_special-view_all {
    color: #005d95;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }

  .skeleton-container {
    width: 245px;
    height: 402px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.12);
    margin-bottom: 48px;
    margin-left: 5px;
    margin-top: 3px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 144px;
      height: 249px;
    }
  }
  .storeSpecialCaraosal .skeleton-container {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-bottom: 4px;
    }
  }
  .skeleton-wrapper {
    padding: 8px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 14px;
    }
  }
  .skeleton-atb {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .skeleton-image {
    width: 217px;
    height: 270px;
    border-radius: 8px;
    margin-bottom: 16px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 128px;
      height: 158px;
    }
  }
  .skeleton-price {
    width: 55px;
    height: 30px;
    border-radius: 8px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 41px;
      height: 22px;
    }
  }
  .skeleton-cart-icon {
    width: 38px;
    height: 40px;
    border-radius: 50%;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 30px;
      height: 30px;
    }
  }
  .skeleton-review {
    height: 36px;
    width: 80%;
    border-radius: 8px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 25px;
    }
  }
`;

export default styles;
